import { createSelector } from '@reduxjs/toolkit'

import { UserState } from '../types/UserState'

export const selectUser = createSelector(
  (state) => state.currentUser,
  (currentUser: UserState) => currentUser.user
)
export const selectActiveRole = createSelector(
  (state) => state.currentUser,
  (currentUser: UserState) => currentUser.currentRole
)
